import type { TrackJSErrorPayload, TrackJSInstallOptions } from 'trackjs';
import { TrackJS } from 'trackjs';

interface InitTrackJsArgs extends Omit<
  TrackJSInstallOptions,
  'application' | 'forwardingDomain' | 'token' | 'version'
> {
  application: string;
  forwardingDomain: string;
  token: string;
  version: string;
}

export const initTrackJS = ({
  application,
  forwardingDomain,
  token,
  version,
  ...rest
}: InitTrackJsArgs) => {
  TrackJS.install({
    application,
    forwardingDomain,
    onError: defaultOnError,
    token,
    version,
    ...rest,
  });
};

const redactCreditCardNumber = (value: string) => {
  if (typeof value === 'string') {
    return value.replace(
      /\b\d{16}\b/gi,
      'REDACTED_POTENTIAL_CREDIT_CARD_NUMBER'
    );
  }

  return value;
};

const defaultOnError = (payload: TrackJSErrorPayload) => {
  if (!payload.stack || !/iheartjane/.test(payload.stack)) {
    return false;
  }
  payload.message = redactCreditCardNumber(payload.message);
  payload.stack = redactCreditCardNumber(payload.stack);
  return true;
};

export const registerErrorMetadata = (key?: string, val?: string) => {
  if (key && val) {
    TrackJS.addMetadata(key, val);
  }
};

export const identify = (userId: string) => {
  TrackJS.configure({ userId });
};

export const debugLog = (log: string) => {
  if (TrackJS.isInstalled()) {
    TrackJS.console.debug(log);
  }
};
